import axios from "axios";

const BASE_URL = "https://backsanpancracio.us-3.evennode.com";

// ✅ GET: Traer todos los provincias
export const getProvincias = async () => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/provincias`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener provincias",
    };
  }
};

// ✅ GET: Traer una provincia por ID
export const getProvinciaById = async (id) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/provincias/${id}`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener provincia",
    };
  }
};

// ✅ POST: Crear nueva provincia
export const postProvincia = async (provinciaData) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/provincias`;

  try {
    const resp = await axios.post(url, provinciaData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al crear provincia",
    };
  }
};

// ✅ PUT: Actualizar provincia
export const putProvincia = async (id, provinciaData) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/provincias/${id}`;

  try {
    const resp = await axios.put(url, provinciaData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar provincia",
    };
  }
};

// ✅ DELETE: Desactivar o eliminar provincia
export const deleteProvincia = async (id) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/provincias/${id}`;

  try {
    const resp = await axios.delete(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar provincia",
    };
  }
};

